<template>
  <div
    class="c-app flex-row align-items-center"
    style="
      background-image: url('https://mdbootstrap.com/img/Photos/Horizontal/Nature/full page/img(11).jpg');
      background-position: center;
      background-repeat: no-repeat;
      background-size: cover;
    "
  >
    <!--<img src="../../assets/image/loginBack.jpg"/>-->
    <CContainer>
      <CRow class="justify-content-center">
        <CCol md="5">
          <CCardGroup>
            <CCard class="pt-0 px-4" style="opacity: 0.8">
              <CCardBody>
                <CForm class="needs-validation">
                  <CRow class="mb-2">
                    <CImg
                      src="../../../img/icon.png"
                      class="col-4"
                      align="center"
                    ></CImg
                  ></CRow>
                  <h3>فراموشی رمزعبور</h3>
                  <p class="text-muted">شماره همراه خود را وارد نمایید:</p>
                  <CInput
                    placeholder="شماره همراه (مثال 09121234569)"
                    type="text"
                    maxlength="11"
                    required
                    v-model="moileInfo.phoneNumber"
                  >
                    <template #prepend-content
                      ><CIcon name="cil-mobile"
                    /></template>
                  </CInput>

                  <label class="text-muted">
                    تصویر امنیتی
                    <span id="InputLoginCaptcha" style="color: #990000"></span>
                  </label>
                  <CInput
                    type="number"
                    placeholder="حاصل جمع"
                    required
                    v-model="moileInfo.captcha"
                  ></CInput>
                  <div
                    style="
                      display: flex;
                      margin-top: 5px;
                      justify-content: center;
                      align-item:center
                    "
                    class="my-2"
                  >
                    <a
                      style="
                        cursor: pointer;
                        float: left;
                        padding-left: 5px;
                        padding-right: 10px;
                        padding-top: 4px;
                      "
                      v-on:click="chagenCaptcha"
                    >
                      <CIcon size="xl" class="text-danger" name="cil-loop-circular" />
                    </a>
                    <img
                      :src="imgCaptcha"
                      alt="Captcha"
                      id="LoginCaptcha"
                      style="float: left"
                    />
                  </div>

                  <CCol col="12" class="text-center">
                    <CButton
                      class="btn px-4 col-12 btn-primary"
                      v-on:click="submitForm"
                      >ارسال</CButton
                    >
                    <!-- <router-link
                      class="btn px-4 col-12 btn-primary"
                      :to="{ name: 'Home' }"
                      >ورود</router-link
                    > -->
                  </CCol>
                </CForm>
              </CCardBody>
            </CCard>
          </CCardGroup>
        </CCol>
      </CRow>
    </CContainer>
    <CModal
      title="عملیات موفق"
      color="success"
      :show.sync="showModal"
      fade
      size="lg"
    >
      رمزعبور شما تغییر یافته و به شماره وارد شده ارسال خواهد شد.
      <template #footer>
        <CButton @click="GoToLogin" color="success">قبول</CButton>
      </template>
    </CModal>
  </div>
</template>

<script>
import router from "../../router";
import axios from 'axios'
export default {
  name: "ForgetPassword",
  data() {
    return {
      moileInfo: { phoneNumber: "", captcha: "" },
      call_api: true,
      showModal: false,
      imgCaptcha: "",
    };
  },

   //***************************** */ mounts
  mounted() {
    axios.get("http://192.168.71.189:5000/Captcha").then((response) => {
      this.setChapcha(response.data);
    });
  },

  methods: {
    //****************************** change captcha */
   chagenCaptcha: function (value) {
    axios.get("http://192.168.71.189:5000/Captcha").then((response) => {
    this.setChapcha(response.data);
  });
  },
  //****************************** set captcha*/
  setChapcha: function (value) {
    this.imgCaptcha = value;
  },
  //*******form validation
    submitForm: function () {
      var forms = document.querySelectorAll(".needs-validation");
      console.log(forms);

      for (var i = 0; i < forms[0].length; i++) {
        if (
          forms[0][i].type == "text" &&
          forms[0][i].required &&
          forms[0][i].value.length <= 10
        ) {
          document.getElementById(forms[0][i].id).style.borderColor = "red";
          this.call_api = false;
        }else if (
          forms[0][i].type == "number" &&
          forms[0][i].required &&
          forms[0][i].value.length == 0
        ) {
          document.getElementById(forms[0][i].id).style.borderColor = "red";
          this.call_api = false;
        }
      }

      if (this.call_api) {
        //Api send new password

        this.showModal = true;
      }

      this.call_api = true;
    },

    GoToLogin: function () {
      router.push({ name: "Login" });
    },
  },
};
</script>

<style scoped>
.no-arrow {
  -moz-appearance: textfield;
}
.no-arrow::-webkit-inner-spin-button {
  display: none;
}
.no-arrow::-webkit-outer-spin-button,
.no-arrow::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
</style>
